module.exports = __webpack_public_path__ + "img/rita_mitsouko.45ced988.jpg";